import { GET_GTIN_REFERENCE, SET_GTIN_REFERENCE } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const gtinReferenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GTIN_REFERENCE:
      return { ...state, isLoading: true };
    case SET_GTIN_REFERENCE:
      return {
        ...state,
        list: action.gtins,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default gtinReferenceReducer;
